import { NUMERIC_FIELD_TYPES, VariableDefinition } from '../variable-schema';
import { toCanonicalNumber } from './numeric-input';
import { formatValueForScss } from './scss-formatting';

export interface Commit {
  value: string | null;
}

export function commitValue(def: VariableDefinition, rawValue: string): Commit | null {
  if (!def.editable) return null;
  if (rawValue === '' && def.emptyValue !== undefined) return { value: def.emptyValue };
  if (NUMERIC_FIELD_TYPES.has(def.type) && toCanonicalNumber(rawValue) === null) return null;
  return { value: formatValueForScss(rawValue, def) };
}
